import { eventFactory } from './utils';

const event = eventFactory('mobile splash');

export const close = (): void => event({ action: 'close' });
export const button = (n: number): void =>
  event({ action: `button ${n} clicked` });
